import { Header } from '../header'
import { Footer } from '../footer'
import './style.scss'

export function BaseLayout({ children }) {
  return (
    <div className='base-layout'>
      <Header />
      <main className='base-layout-content'>{children}</main>
      <Footer />
    </div>
  )
}
